webpackJsonp([197271783010938],{

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(17);
	
	var _Layout = __webpack_require__(64);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _Layout2.default,
	    null,
	    _react2.default.createElement(_components.PageTitle, { title: '\u4F18\u52BF\u4EF7\u503C' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-worth-js-cfc422d3d69537d8d029.js